var styleDataHash = "2760017a";
const injectCss = (() => {
  var css = `@charset "UTF-8";.GmNZP,.ReactModalPortal,.glob_fontElementMap,.zhyQ3,button{font-family:var(--ricos-font-family,unset)}.VQdT-{display:flex}.DzI1E,._1UIFv:hover{border-radius:var(--ricos-native-whitebox-border-radius,0);box-shadow:0 0 0 1.5px #116dff;cursor:default}.ph3LJ .DzI1E,[data-hook^=figure-][data-cropping] .DzI1E{box-shadow:none!important}.ph3LJ :is([data-resize-handle],[data-hook=image-corner-radius-handle],[data-hook=image-corner-radius-label]){display:none!important}.qoSuz{cursor:move;display:block;height:100%;left:0;position:absolute;top:0;width:100%}.qoSuz._9l1tT{pointer-events:none}.hxjoz ::selection{background:transparent}.OiEzY{display:none}.zhyQ3{position:relative}._2C32a{max-width:100%}.ReactModal__Body--open{overflow-y:hidden}.ReactModal__Content{direction:ltr;font-weight:300}.ReactModalPortal{color:var(--ricos-settings-text-color,#333)}.ReactModalPortal,.ReactModalPortal input{font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif)}.L-f3f{color:#333;text-decoration:none}.eUOlD{display:block}.kbEm1{position:relative}.NWrI9{margin-left:-20px;margin-right:-20px;overflow-x:auto;overflow-y:hidden}.NWrI9.tkAaV::-webkit-scrollbar-thumb{background-color:rgba(0,0,0,.5)}.NWrI9._25-zu::-webkit-scrollbar-thumb{background-color:transparent}.AGK7l{max-width:max-content!important;min-width:100%}.NWrI9::-webkit-scrollbar{-webkit-appearance:none}.NWrI9::-webkit-scrollbar-thumb{border:2px solid #fff;border-radius:8px}.NWrI9::-webkit-scrollbar:horizontal{height:10px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var general_default = {
  "fontElementMap": "GmNZP",
  "pluginContainer": "zhyQ3",
  "flex": "VQdT-",
  "isFocusable": "_1UIFv",
  "hasFocus": "DzI1E",
  "dragImageView": "ph3LJ",
  "overlay": "qoSuz",
  "noPointerEventsOnFocus": "_9l1tT",
  "hideTextSelection": "hxjoz",
  "hidden": "OiEzY",
  "pluginContainerMobile": "_2C32a",
  "isImage": "L-f3f",
  "anchor": "eUOlD",
  "horizontalScrollbarWrapper": "kbEm1",
  "pluginWithHorizontalScrollbar": "NWrI9",
  "show": "tkAaV",
  "hide": "_25-zu",
  "horizontalScrollbar": "AGK7l"
};
export {
  general_default as default,
  injectCss
};
//# sourceMappingURL=general-scss.js.map
